/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

logoStyles.heading = {
    css: css`
        display: none;
    `,
};

logoStyles.container = {
    css: css`
        width: 80px;
        height: 80px;
        border-radius: 4px;
        border: 1px solid ${getColor("common.ui12")};
        overflow: hidden;
        float: left;
        margin-right: 15px;

        &:after {
            content: " ";
            display: table;
            clear: bottom;
        }
    `,
};

logoStyles.image = {
    css: css`
        width: 100%;

        img {
            height: 100%;
            object-fit: contain;
            object-position: center;
        }
    `,
};
